import React, { useState, useRef } from 'react';
import _ from 'lodash';
import DropdownSelector from '../dropdowns/DropdownSelector';
import FieldTreesApi from '../../services/fieldTrees/FieldTreesApi';
import { USER_ROLES } from '../../utilities/constants';
import {
  FullName,
  PartnerCompany1Ids,
  RoleCodes,
  SearchCondition,
} from '../../services/lwUser/SearchCondition';

/**
 * 検索条件表示部分
 * @param {number} fieldId 現場ID
 * @param {SearchCondition} searchCondition 検索条件データ
 * @param {function} setSearchCondition 検索条件を更新する関数
 * @param {SearchCondition} tempSearchCondition 検索条件(保存用)データ
 * @param {function} setTempSearchCondition 検索条件(保存用)を更新する関数
 * @param {boolean} isLoading ローディング状態
 * @param {function} setIsLoading ローディング状態にセット
 **/
function RenderSearchCondition({
  fieldId,
  setSearchCondition,
  tempSearchCondition,
  setTempSearchCondition,
  isLoading,
  setIsLoading,
}) {
  const [isOpen, setOpenStatus] = useState(true);
  const toggleOpen = () => {
    setOpenStatus(prevStatus => !prevStatus);
  };
  const textInput = useRef(null);
  const _setName = e => {
    const name = e.target.name;
    const value = e.target.value;
    _setSearchCondition(name, value);
  };
  const _setSearchCondition = (name, value) => {
    switch (name) {
      case 'fullname':
        setTempSearchCondition(prevStatus =>
          prevStatus.setFullName(new FullName(value))
        );
        break;
      case 'partnercompany1ids':
        setTempSearchCondition(prevStatus =>
          prevStatus.setPartnerCompany1Ids(new PartnerCompany1Ids(value))
        );
        break;
      case 'rolecodes':
        setTempSearchCondition(prevStatus =>
          prevStatus.setRoleCodes(new RoleCodes(value))
        );
        break;
    }
  };
  const clearSearchCondition = () => {
    textInput.current.value = '';
    setTempSearchCondition(new SearchCondition());
    setSearchCondition(new SearchCondition());
  };
  const mainJvCompany = 1;
  return (
    <div className='search-panel'>
      <div className='search-panel__header'>
        <div className='search-panel__title'>検索条件</div>
        <button
          className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
          onClick={toggleOpen}
        />
        <button className='btn-text--sm' onClick={clearSearchCondition}>
          検索条件クリア
        </button>
      </div>
      {isOpen && (
        <div className='search-panel__item'>
          <div className='panel-item form-search'>
            <div className='panel-item__select'>
              <div className='panel-item__select-label'>
                <div className='label'>氏名</div>
              </div>
              <div className='panel-item__select-element'>
                <input
                  className='FormInput'
                  name='fullname'
                  type='text'
                  placeholder='ユーザー名'
                  ref={textInput}
                  onBlur={_setName}
                />
              </div>
            </div>
          </div>
          <div className='search-form-element'>
            <div className='multi-select-box__label'>
              <span className='label'>一次協力会社</span>
            </div>
            <div className='multi-select-box__element'>
              <DropdownSelector
                widthClass='dropdown__item--wide'
                itemWidthClass='multi-select__item'
                label='一次協力会社を選択'
                dropdownSelectStyle={{ width: '190px' }}
                selectorName='partnercompany1ids'
                selectedValues={tempSearchCondition.partnerCompany1Ids.list}
                keyName='company_name'
                valueName='company_id'
                multiple
                api={params =>
                  FieldTreesApi.fetchFieldTreeCompanyBranchList(fieldId, params)
                }
                apiParams={{
                  nest_no: mainJvCompany,
                }}
                apiSearchKey='name'
                apiBindDataKey='field_trees'
                onSelect={_setSearchCondition}
              />
            </div>
            <div className='multi-select-box__label'>
              <span className='label'>ユーザー種別</span>
            </div>
            <div className='multi-select-box__element'>
              <DropdownSelector
                itemWidthClass='multi-select__item'
                label='ユーザー種別を選択'
                dropdownSelectStyle={{ width: '190px' }}
                selectorName='rolecodes'
                selectedValues={tempSearchCondition.roleCodes.list}
                keyName='role_name'
                valueName='role_id'
                multiple
                options={[
                  {
                    role_name: USER_ROLES.branch.name,
                    role_id: USER_ROLES.branch.id,
                  },
                  {
                    role_name: USER_ROLES.manager.name,
                    role_id: USER_ROLES.manager.id,
                  },
                  {
                    role_name: USER_ROLES.partner.name,
                    role_id: USER_ROLES.partner.id,
                  },
                  {
                    role_name: USER_ROLES.foreman.name,
                    role_id: USER_ROLES.foreman.id,
                  },
                ]}
                onSelect={_setSearchCondition}
              />
            </div>
            <button
              className='btn-fixedsize--stay search-form__btn'
              onClick={() => {
                if (isLoading) return;
                setIsLoading(true);
                setSearchCondition(_.cloneDeep(tempSearchCondition))
              }}
            >
              検索
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export { RenderSearchCondition };



// WEBPACK FOOTER //
// ./src/components/lwUser/searchCondition.jsx